const NewsSearchPage = () => import('./news_search/NewsSearchPage.vue')
const ReportsSearchPage = () => import('./reports_search/ReportsSearchPage.vue')
export default [
	{
		path: '/iro/news/search',
		component: NewsSearchPage,
		props: {
			permission: ['iro', 'r']
		}
	},
	{
		path: '/iro/reports/search',
		component: ReportsSearchPage,
		props: {
			permission: ['iro', 'r']
		}
	}
]
